import { render } from "./MypageBadge.vue?vue&type=template&id=65d3a4a3&ts=true"
import script from "./MypageBadge.vue?vue&type=script&lang=ts"
export * from "./MypageBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QIcon});
